<template>
  <div class="sc-form-select-container" :class="[marginClasses, sizeClasses]">
    <div
      class="sc-select-box sc-year-select"
      :class="{ 'sc-select-has-error': error, disabled: disabledClass }"
    >
      <div
        :ref="`${computedName}-sc-selectbox`"
        @click="showOptions = !showOptions"
        class="sc-select-button brd"
        :class="{
          'open-select-box': showOptions,
        }"
      >
        <div class="sc-selected-value">
          <input
            class="sc-select-input sc-year"
            type="text"
            v-model="select_query"
            autocomplete="off"
          />
        </div>
        <div class="sc-select-chevrons">
          <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
        </div>
      </div>
      <transition enter-active-class="fadeInTop" mode="out-in">
        <div
          :id="`${computedName}-sc-options`"
          v-show="showOptions"
          v-closable="{
            exclude: [`${computedName}-sc-selectbox`],
            handler: 'onClose',
          }"
          class="sc-options"
        >
          <div class="sc-option sc-option-placeholder">
            <span class="sc-select-option-label">{{ placeholder }}</span>
          </div>
          <template v-if="options.length">
            <div
              class="sc-option"
              :class="{ 'sc-selected': value == option }"
              v-for="(option, index) in options"
              :key="id + '_' + index + '_' + option"
              @click="handleInput(index)"
            >
              <span class="sc-select-option-label">{{ option }}</span>
            </div>
          </template>
          <template v-else>
            <div class="sc-option">
              <span class="sc-select-option-label">Nothing found</span>
            </div>
          </template>
        </div>
      </transition>
    </div>
    <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
      <div v-if="error" class="input-error">
        <img :src="`${scBaseUrl}/assets/images/Error.svg`" alt="Error" />
      </div>
    </transition>
    <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
      <div v-if="success" class="input-checked">
        <img :src="`${scBaseUrl}/assets/images/Checked.svg`" alt="Checked" />
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Object, Boolean],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Please select one",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    options: {
      required: true,
      type: Array,
    },
    size: {
      default: "w-full",
      type: String,
    },
    margin: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    form: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      selectedOption: "",
      showOptions: false,
    };
  },
  mounted() {
    this.selectedOption = this.options.find((option) => option == this.value);
  },
  computed: {
    sizeClasses() {
      return this.size;
    },
    computedName() {
      if (this.name) {
        return this.name;
      } else if (this.id) {
        return this.id;
      } else {
        return "";
      }
    },
    marginClasses() {
      return this.margin;
    },
    disabledClass() {
      if (this.value.length) {
        return false;
      }
      return true;
    },
    availableOptions() {
      let options = this.options || [];
      if (!this.select_query.length) {
        return options;
      }
      return options.filter((option) => {
        return `${option[this.optionLabel]} ${option[this.optionSubLabel]}`
          .toLowerCase()
          .includes(this.select_query.toLowerCase());
      });
    },
    select_query() {
      return this.selectedOption || this.placeholder;
    },
  },
  watch: {
    value() {
      this.selectedOption = this.value;
    },
    showOptions() {
      setTimeout(() => {
        let optionsEle = document.getElementById(
          `${this.computedName}-sc-options`
        );
        let options = optionsEle.getElementsByClassName("sc-option");
        for (const option in options) {
          if (
            typeof options[option] == "object" &&
            options[option].className.indexOf("sc-selected") != -1
          ) {
            let scrollTo = (option + 1) * 4 - 100;
            optionsEle.scrollTop = scrollTo;
          }
        }
      }, 100);
    },
  },
  methods: {
    handleInput(index) {
      //   Here index is the index of the selected object
      this.selectedOption = this.options[index];
      const valueToEmit = this.options[index];
      this.$emit("input", valueToEmit);
      this.$emit("change");
      this.onClose();
    },
    onClose() {
      this.showOptions = false;
    },
  },
};
</script>

<style scoped>
.sc-selected-value input[type="text"] {
  color: #97a1b1;
}
</style>



// WEBPACK FOOTER //
// BaseYearSelect.vue?cca97628